import { render, staticRenderFns } from "./AddBusinessDatabus.vue?vue&type=template&id=f9b1d54a&scoped=true"
import script from "./AddBusinessDatabus.vue?vue&type=script&lang=js"
export * from "./AddBusinessDatabus.vue?vue&type=script&lang=js"
import style0 from "./AddBusinessDatabus.vue?vue&type=style&index=0&id=f9b1d54a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9b1d54a",
  null
  
)

export default component.exports